import { getConfig } from '../config';

export const isProd = () => getConfig().env === 'prod';
